export const handleImmixEmailInput = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: any,
  objectId: number
) => {
  const newObject = camerasObject[objectId];

  newObject.immix.immix_email = inputString;

  setCamerasObject((previousState: any) => {
    return { ...previousState, objectId: newObject };
  });
};
